<template>
    <div>
        <div v-if="errorMessage.length">
            {{errorMessage}}
        </div>

        <template v-if="loaded">

            <div class="topbar topbar--full">
                
                <router-link to="/trackers" class="link-back">All Trackers</router-link>
                
                <div class="topbar__inner">
                    <h2 class="tracker-name heading2">
                        {{ info.name }}
                    </h2>

                    <div class="topbar__side">
                        <ul class="actions-list">
                            <li>
                                <div>
                                    <b-dropdown id="dropdown-1" text="Actions" class="topbar__side__actions icons-list dropdown-simple">
                                        <b-dropdown-item class="action icons-list__edit" @click="edit">
                                            Edit Folder
                                        </b-dropdown-item>

                                        <b-dropdown-item class="action icons-list__delete" @click="remove">
                                            <font-awesome-icon :icon="['fa', 'trash']" />
                                            Delete
                                        </b-dropdown-item>

                                        <b-dropdown-item class="action icons-list__archive" v-if="!info.archived" @click="archive">
                                            Archive
                                        </b-dropdown-item>

                                        <b-dropdown-item class="action icons-list__archive" v-else @click="unarchive">
                                            Unarchive
                                        </b-dropdown-item>

                                        <b-dropdown-item class="action icons-list__add" @click="openAddTrackers">
                                            Add Trackers
                                        </b-dropdown-item>

                                    </b-dropdown>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="main-inner">
                <template v-if="trackersLoaded">

                    <header class="main-inner__header">
                        <h2 class="heading2">Trackers</h2>

                        <a v-if="arrayHelper.inArray($store.state.user.permissions, 'tracker-create')" class="link" @click="$refs.editTracker.open(0)">+ New Tracker</a>

                        <p class="main-inner__header__info" v-if="trackersStatus == 'active'">
                            Showing {{ trackers.active.length }} active tracker(s) <a v-if="trackers.archived.length" @click="trackersStatus = 'archived'" class="link-inherit ml-3">Show archived trackers</a>
                        </p>

                        <p class="main-inner__header__info" v-if="trackersStatus == 'archived'">
                            Showing {{ trackers.archived.length }} archived tracker(s) <a v-if="trackers.active.length" @click="trackersStatus = 'active'" class="link-inherit ml-3">Show active trackers</a>
                        </p>
                    </header>
                    
                    <table class="main-table" v-if="trackers[trackersStatus].length">
                        <thead>
                        <tr>
                            <th>Tracker Name</th>
                            <th>Description</th>
                            <th>Startups</th>
                            <th>Type</th>
                            <th>Permissions</th>
                            <th>Last Modified</th>
                            <th>Actions</th>
                        </tr>
                        </thead>

                        <tbody>
                        <tr v-for="tracker in trackers[trackersStatus]" :key="tracker.id">
                            <td><router-link :to="'/trackers/' + tracker.id">{{ tracker.name }}</router-link></td>
                            <td v-html="tracker.description"></td>
                            <td>{{ tracker.startups_count }}</td>
                            <td>{{ constants.trackerTypes[tracker.type] }}</td>
                            <td>
                                <b-dropdown class="dropdown--secondary ml-auto" variant="link" toggle-class="text-decoration-none" no-caret>
                                    <template #button-content>
                                        <div class="section-users mr-2">
                                            <div class="section-users__images">
                                                <div v-for="(avatar, index) in stringHelper.getAvatarsForDisplay(tracker.permissions)" :key="index" class="section-users__images__item">
                                                    <img :src="avatar" style="width: 30px;" alt=""/>
                                                </div>
                                            </div>
                                            <p>
                                                <a v-for="(item, index) in stringHelper.getPermissionNamesForDisplay(tracker.permissions)" :key="index">
                                                    {{item}}
                                                </a>
                                            </p>
                                        </div>
                                    </template>

                                    <b-dropdown-header>
                                        <header class="dropdown__header-inner">
                                            <h4 class="heading4">Users in {{ tracker.name }}</h4>

                                            <a v-if="false" href="#" class="link link--lg">Edit</a>
                                        </header>

                                        <ul class="rows-list">
                                            <li  v-for="(permission, index) in tracker.permissions" :key="index">
                                                <div class="rows-list__avatar">
                                                    <Avatar
                                                        :username="permission.name"
                                                        :src="permission.avatar"
                                                        :size="30">
                                                    </Avatar>
                                                </div>

                                                <h5 class="heading5 heading5--secondary">{{ permission.name }}</h5>

                                                <!-- Please add here the logic first -->
                                                <p class="ml-auto">{{ permission.role.name }}</p>
                                                <a class="link-info" href="#">
                                                    <span class="link-info__content">{{ permission.role.description }}</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </b-dropdown-header>
                                </b-dropdown>
                            </td>
                            <td>
                                {{tracker.last_modified}}
                            </td>
                            <td>
                                <div class="card flex-row">
                                    <b-dropdown v-if="tracker.user_can_edit || tracker.user_can_archive" class="ml-5 drag-n-drop icons-list dropdown-simple" boundary="viewport">
                                        <b-dropdown-item v-if="tracker.user_can_edit" class="icons-list__edit" @click="$refs.editTracker.open(tracker.id)">
                                            Edit Tracker
                                        </b-dropdown-item>

                                        <b-dropdown-item v-if="tracker.user_can_edit" class="icons-list__delete" @click="removeTracker(tracker.id)">
                                            <font-awesome-icon :icon="['fa', 'trash']" />
                                            Delete Tracker
                                        </b-dropdown-item>

                                        <b-dropdown-item v-if="tracker.user_can_archive && tracker.status != 'archive'" class="icons-list__archive" @click="archiveTracker(tracker.id)">
                                            Archive
                                        </b-dropdown-item>
                                    </b-dropdown>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>

                    <div v-if="!trackers.active.length && !trackers.archived.length" class="card card--bordered card--ordered">
                        <header class="card__header">
                            <h4 class="heading4 heading4--secondary">No Trackers</h4>
                        </header>

                        <div class="card__inner">
                            <div class="card__inner__side">
                                <p>You haven’t created any trackers.</p>
                                <p>Trackers allow you to keep tabs on startups and perform diligence on them. You can also use trackers
                                    to create steps  to move startups through as you gather more information to determine their compatibility
                                    with your needs.</p>
                            </div>
                            <div class="card__controls ml-auto">
                                <b-button variant="primary" size="lg" @click="$refs.editTracker.open(0)">Create A Tracker</b-button>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </template>

        <editFolder
            ref="editFolder"
            v-on:folderSaved="getInfo"
        >
        </editFolder>

        <edit-tracker
            ref="editTracker"
            :folder-id="id"
            v-on:trackerSaved="getTrackersList"
        >
        </edit-tracker>

        <add-trackers
            ref="addTrackers"
            :trackers-list="trackersToAdd"
            v-on:trackersSelected="addTrackers"
        >
        </add-trackers>

    </div>
</template>

<script>

import trackers from "@/services/trackers.service";
import editFolder from "@/components/trackers/EditFolder"
import editTracker from "@/components/trackers/EditTracker";
import Avatar from "vue-avatar";
import AddTrackers from "@/components/manage/SelectTrackers";

export default {
    data() {
        return {
            id: parseInt(this.$route.params.id),

            info: {
                name: '',
                description: '',
            },
            loaded: false,
            errorMessage: "",

            trackers: {
                active: [],
                archived: [],
            },

            trackersStatus: 'active',
            trackersLoaded: 0,

            trackersToAdd: [],
        }
    },

    components: {
        editFolder,
        editTracker,
        Avatar,
        AddTrackers
    },

    mounted() {
        this.getInfo()
        this.getTrackersList()

        this.$store.watch(state => {
            if (state.needUpdateTrackers) {
                this.getTrackersList()
            }
        })
    },

    methods: {
        getInfo() {
            trackers.getFolderInfo(this.id).then(response => {
                this.info = response.data
                document.title = this.info.name + ' | SwitchPitch'
                this.loaded = true
            }).catch(error => {
                this.errorMessage = error.response.data.message
            })
        },

        getTrackersList() {
            trackers.getFolderTrackersIndex(this.id).then(response => {
                this.trackers = response.data
                this.trackersLoaded = true

                if (this.trackersType == null) {
                    if (this.trackers.active.length) {
                        this.trackersType = 'active'
                    }
                    else if (this.trackers.archived.length) {
                        this.trackersType = 'archived'
                    }
                }
            })
        },

        archive() {
            if (this.trackers.active.length) {
                if (confirm("Archive folder and all it's trackers?")) {
                    trackers.archiveFolder(this.id).then(() => {
                        this.getTrackersList()
                        this.getInfo()
                    })
                }
            }
            else {
                trackers.archiveFolder(this.id).then(() => {
                    this.getTrackersList()
                    this.getInfo()
                })
            }
        },

        unarchive() {
            if (this.trackers.archived.length) {
                if (confirm("Unarchive folder and all it's trackers?")) {
                    trackers.unarchiveFolder(this.id).then(() => {
                        this.getTrackersList()
                        this.getInfo()
                    })
                }
            }
            else {
                trackers.unarchiveFolder(this.id).then(() => {
                    this.getTrackersList()
                    this.getInfo()
                })
            }
        },

        remove() {
            if (this.trackers.active.length || this.trackers.archived.length) {
                if (confirm("Delete folder and all its trackers?")) {
                    trackers.deleteFolder(this.id).then(() => {
                        this.$router.push('/trackers')
                    })
                }
            }
            else {
                trackers.deleteFolder(this.id).then(() => {
                    this.$router.push('/trackers')
                })
            }
        },

        edit() {
            this.$refs.editFolder.open(this.id)
        },

        removeTracker(id) {
            trackers.delete(id).then(() => {
                this.getTrackersList()
            })
        },

        archiveTracker(id) {
            trackers.update(id, {status: 'archive'}).then(() => {
                this.getTrackersList()
            })
        },

        openAddTrackers() {
            trackers.getList().then(response => {
                this.trackersToAdd = []

                response.data.forEach(item => {
                    if (this.arrayHelper.findIndexByColumnValue(this.trackers.active, 'id', item.value) < 0 &&
                        this.arrayHelper.findIndexByColumnValue(this.trackers.archived, 'id', item.value)) {
                        this.trackersToAdd.push(item)
                    }
                })
            })

            this.$refs.addTrackers.open()
        },

        addTrackers(addedTrackers) {
            let trackerIds = this.arrayHelper.arrayColumn(addedTrackers, 'value')
            trackers.addToFolder(this.id, trackerIds).then(() => {
                this.getTrackersList()
            })
        }
    }
}

</script>

<style scoped>

</style>